import { useState } from "react";

import CsvOverview from "../CsvOverview";
import ScrollAndFooter from "../ScrollAndFooter";
import CsvUpload from "./CsvUpload";

import type { CsvState, ListLeadListSource } from "../../../types";

interface CustomListProps {
  createSource: (params: { settings: ListLeadListSource["settings"] }) => void;
  isCreatingSource: boolean;
}

export default function CustomList({
  createSource,
  isCreatingSource,
}: CustomListProps) {
  const [uploadState, setUploadState] = useState<
    { csvState: CsvState } & { sourceName: string }
  >();
  const [mainIdentifier, setMainIdentifier] = useState(undefined);

  return (
    <ScrollAndFooter
      isCreateDisabled={!uploadState || !mainIdentifier}
      isCreatingSource={isCreatingSource}
      onCreate={() =>
        createSource({
          settings: {
            type: "list",
            profiles: uploadState.csvState.parsed,
            url_column: mainIdentifier,
          },
        })
      }
    >
      <div className="flex flex-col max-w-135 m-auto w-full">
        {uploadState ? (
          <CsvOverview
            uploadState={uploadState}
            mainIdentifier={mainIdentifier}
            setMainIdentifier={setMainIdentifier}
            reset={() => {
              setUploadState(undefined);
              setMainIdentifier(undefined);
            }}
          />
        ) : (
          <CsvUpload
            onSuccess={(csvState, fileName) => {
              setUploadState({ csvState, sourceName: fileName });
              //undefined when the file has no url column, which also clears the
              //identifier picked for a previously uploaded file
              setMainIdentifier(csvState.url_columns[0]);
            }}
          />
        )}
      </div>
    </ScrollAndFooter>
  );
}
